import Logo from "@commons/Logo";
import Heading from "@commons/Typography/Heading";
import loginImage from "@public/assets/images/login-image.webp";
import LoginForm from "../components/loginForm";

function LoginScreen() {
  return (
    <main className="flex min-h-screen w-screen items-center justify-center bg-white">
      <div className="flex h-screen w-full flex-col md:flex-row overflow-hidden">
        <aside className="hidden md:block md:basis-[80%] xl:basis-[50%]">
          <img
            src={loginImage}
            alt="Ilustração de login"
            className="h-full w-full object-cover"
          />
        </aside>
        <div className="overflow-auto w-full">
          <section className="flex flex-1 items-center justify-center p-6 sm:p-12">
            <div className="flex w-full max-w-md flex-col items-center gap-6 py-8">
              <Logo size="lg" className="mb-12 sm:mb-16" />
              <Heading size="md" className="w-full text-start font-sans">
                Acesso à plataforma Guará
              </Heading>
              <LoginForm />
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}

export default LoginScreen;
